import flagsmith from '@flagsmith/flagsmith'

import type { IInitConfig } from '@flagsmith/flagsmith/types'

export const flagsmithOptions: IInitConfig = {
  environmentID:
    import.meta.env.VITE_APP_FLAGSMITH_ENV_ID ?? '5EyXQPZkR6vUQv8Dcsc3kK',
  api: import.meta.env.VITE_APP_FLAGSMITH_API ?? '/flagsmith/api/v1/'
}

export { flagsmith }
